import { useCurrency } from '@features/currency/currency.hooks';

const TotalPriceCell = (props: { totalPrice: number }) => {
  const { preferredCurrency } = useCurrency();
  return (
    <>
      {Math.round(props.totalPrice)}
      <span style={{ color: '#888', marginLeft: 0 }}>{` ${preferredCurrency}`}</span>
    </>
  );
};

export default TotalPriceCell;
